import Accordion from '@/common/components/Accordion'
import MaintenanceObjective from '@/common/components/MaintenanceObjective'
import { formatCurrency } from '@/common/utils/formatters'
import DiagnosticEntryObjectiveActivities from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Content/DiagnosticEntryCompleted/DiagnosticEntryObjectiveActivities'
import DiagnosticEntryObjectivePieces from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs/Sections/DirectiveEntry/Content/DiagnosticEntryCompleted/DiagnosticEntryObjectivePieces'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { useMemo } from 'react'

const EstablishmentChoiceEntryProposalDiagnostic = () => {
  const { forwarding, forwardingUpdatedAt } =
    useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>()

  const objectivesCountDisplay = useMemo(() => {
    if (Number(forwarding?.directive_entry?.objectives?.length) > 0) {
      if (Number(forwarding?.directive_entry?.objectives?.length) === 1) {
        return '(1 Objeto)'
      }

      return `(${Number(forwarding?.directive_entry?.objectives?.length)} Objetos)`
    }

    return ''
  }, [forwarding?.directive_entry?.objectives?.length])

  return (
    <Accordion
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      defaultOpen
      head={
        <div className="flex items-center justify-between w-full mr-2">
          <p>Orçamento {objectivesCountDisplay}</p>

          <div className="flex items-center gap-0.5 text-xs">
            <span>Valor total</span>

            <span>•</span>

            <span className="text-valid">
              {formatCurrency(Number(forwarding?.directive_entry?.diagnostic?.total_value) || 0)}
            </span>
          </div>
        </div>
      }
      body={
        <div className="flex flex-col gap-1.5">
          {forwarding?.directive_entry?.objectives?.map((objective) => (
            <Accordion
              key={objective.id}
              defaultOpen
              className="p-0 rounded-lg"
              triggerClassName="p-4"
              bodyClassName="p-4 pt-0"
              head={
                <MaintenanceObjective
                  systemDisplayName={objective.system.display_name}
                  actionDisplayName={objective.action.display_name}
                  partDisplayName={objective.part.display_name}
                  actionDescription={objective.action.description}
                />
              }
              body={
                <div className="flex flex-col gap-3">
                  <DiagnosticEntryObjectivePieces objective={objective} dataUpdatedAt={forwardingUpdatedAt} />

                  <DiagnosticEntryObjectiveActivities objective={objective} dataUpdatedAt={forwardingUpdatedAt} />
                </div>
              }
            />
          ))}
        </div>
      }
    />
  )
}

export default EstablishmentChoiceEntryProposalDiagnostic
